// Google Analytics 4 wiring — activates automatically when REACT_APP_GA_ID is set
// in /app/frontend/.env (format: G-XXXXXXXXXX). Until then it is a no-op.

const GA_ID = process.env.REACT_APP_GA_ID;

let initialized = false;

export const initAnalytics = () => {
  if (!GA_ID || initialized) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
};

export const trackPageView = (language) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: window.location.pathname,
    page_title: document.title,
    language,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", eventName, params);
};
